<template>
  <ul class="list-group directory-tree">
    <li v-for="e in entries"
        :key="e.obj.obj_id"
        @dblclick="toggle(e)"
        @click="select(e.obj)"
        :class="{active: selected == e.obj}"
        :style="{paddingLeft: 20 + e.level * 10 + 'px'}"
        class="list-group-item list-group-item-action directory-tree py-1">
      <div v-if="e.updating" class="ui tiny active inline loader"></div>
      <i v-if="e.expanded" class="caret down icon" @click="collapse(e)"></i>
      <i v-else class="caret right icon" @click="expand(e)"></i>
      <i class="folder icon"></i>
      <span class="dir-name">{{ entry_name(e) }}</span>
    </li>
  </ul>
</template>

<script>

class DirEntry {
  constructor(level, dir) {
    this.level = level;
    this.expanded = false;
    this.updating = false;
    this.obj = dir;
    this.next = null;
  }
}

export default {
  name: 'DirectoryTree',
  props: ['root'],
  data: function () {
    return {
      selected: null,
      entry_head: new DirEntry(0, this.root),
      entries: [],
    };
  },
  methods: {
    reset() {
      var e = new DirEntry(0, this.root);
      this.entry_head = e;
      this.compute_entries();
      var first = this.entries[0];
      this.expand(first);
      this.select(this.root);
    },
    entry_name(e) {
      return e.obj.name ? e.obj.name : "我的网盘";
    },
    select(e) {
      this.selected = e;
      this.$emit('change', e);
    },
    toggle(e) {
      if (e.expanded) {
        this.collapse(e);
      } else {
        this.expand(e);
      }
      return false;
    },
    cmp_entry(a, b) {
      return a.name.localeCompare(b.name);
    },
    expand(e) {
      if (e.expanded || e.updating) return;
      e.updating = true;
      e.obj.populate().then(() => {
        if (!e.updating) {
          return;
        }
        var next = e.next;
        var prev = e;
        var level = e.level + 1;
        var children = Array.from(e.obj.children);
        children.sort(this.cmp_entry);
        for (var i in children) {
          var c = children[i];
          if (e.obj == this.root && c.name == ".mods") {
            continue;
          }
          if (c.type != "dir") {
            continue;
          }
          prev.next = new DirEntry(level, c);
          prev = prev.next;
        }
        prev.next = next;
        this.compute_entries();
        e.expanded = true;
        e.updating = false;
      });
    },
    collapse(e) {
      if (e.updating) return;
      e.updating = true;
      var p = e.next;
      while (p && p.level > e.level) {
        p = p.next;
      }
      e.next = p;
      e.expanded = false;
      e.updating = false;
    },
    compute_entries() {
      var r = [];
      for (var p = this.entry_head; p; p = p.next) {
        r.push(p);
      }
      this.entries = r;
    }
  },
  computed: {
  },
  mounted() {
    this.select(this.default);
    this.reset();
  },
}
  
</script>

<style scoped>

.folder-icon {
  margin-right: 8px;
  color: Gray;
}

.dir-name {
  margin-left: 4px;
  user-select: none;
}

.caret.icon {
  color: grey;
}

.folder.icon {
  color: #666;
}

.active>.folder.icon {
  color: teal;
}

.active {
  background-color: #DAE2EC !important;
  color: teal;
  font-weight: bold;
}
</style>
